
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue?macro=true";
import { default as _91slug_93tG3BgjS_45cJ7ztz5qeFC21x_E16H9vIJo4WDQpeaCCrkMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue?macro=true";
import { default as faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue?macro=true";
import { default as pstYOttUq2Q_45fGLzjzik35h6hKO40jGiQgf06o1LaJha3YMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue?macro=true";
import { default as indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/index.vue?macro=true";
import { default as indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue?macro=true";
import { default as _91slug_93bQU3nb1TflpW1eoHPQqArt_Z1sTbsR_xZlTBpILnY0AMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue?macro=true";
import { default as legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue?macro=true";
import { default as promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue?macro=true";
import { default as privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/private.vue?macro=true";
import { default as fb7mpvDyCwCYq0GPUw0choao44OkxGu0vZaHPNFPNs1j0Meta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue?macro=true";
import { default as affiliateuQ__fBmiYCxKaXVEvVFrxbgcH2ooYH9pSgTRBB9dfLMMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue?macro=true";
import { default as adv3dX1Ps0pGHZ8tSmj5_jZOqXdnMnEmlxT_OA9ttxqzNcMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue?macro=true";
import { default as extension1jpmRiZzCyA3DpLMilKsQbdntzy49hHcRL3uj7FWWOsMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue?macro=true";
import { default as worldwidewcxwcEae5cfoVOjwXtjDYlgTsrx5j6E0LdgTGThJ_5gMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue?macro=true";
import { default as mobile_45appnNzu2lXX70RHAVU_JgbmF9l3LEHUNxqkwoQWNl5YYPcMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue?macro=true";
import { default as whitelabel9diTvvuKXiBLZ4vIl4QvU2RFBRTWfj3SuiOG6SzhswMMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue?macro=true";
import { default as indexea_45A0k03YWLUZ0fr5fcLMDhAipkDyiwUFPXSGtASfvEMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue?macro=true";
import { default as _91slug_93l2OQiwyq141hizJzHyzOXQfeBfBUvxr_3G6VB3sViPMMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue?macro=true";
import { default as ultimagwFPDl8e_453q7TAajfAHfpWsZfbHHlmeFcGXg43BgCbcMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue?macro=true";
import { default as indexs5_45PfLHiAaGcRUiYSnTmzPvsupE_45jPK56CXiP0UfTtgMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue?macro=true";
import { default as platinumD_tYhwMj3YvjKsEIUQk_45kb8i8xqLGa_M_cYQdzJt0k8Meta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue?macro=true";
import { default as _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue?macro=true";
import { default as _91slug_93SV_452gUVyYM6e_j8rk_56GbBHw7g0FQ0jJezwBktpf1UMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue?macro=true";
import { default as private_45landingplJuFGPWKwlz3NTKJ1zrhkFHOxLrTS33RfrL_45WgPBsMMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue?macro=true";
import { default as payment_45cardGw5Fc88LQ9jCLyl1yM1PaNJS_PZUzKsnGlybUBLzRXoMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue?macro=true";
import { default as virtual_45debit_45cardizNOre15Vi8HxO83Z9YhqSF3D3FJB6TqbIEADMj_45UNsMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue?macro=true";
import { default as virtual_45prepaid_45card3R4pMUvQLrd7Ac0e3JbFhmJhJBURczgle3FjYWA0qcUMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue?macro=true";
import { default as pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta } from "/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue?macro=true";
import { default as component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta } from "/home/server/builds/landing-2025-04-22-14-33/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0 } from "/home/server/builds/landing-2025-04-22-14-33/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ru/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ru",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ru",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___en",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___en",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/es/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___es",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___es",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/fr/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___fr",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___fr",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/de/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___de",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___de",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/it/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___it",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___it",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/pt/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___pt",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___pt",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/zh/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___zh",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___zh",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/bg/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___bg",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___bg",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/tr/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___tr",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___tr",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ja/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ja",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ja",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ua/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ua",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ua",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/th/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___th",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___th",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/hi/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___hi",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___hi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/be/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___be",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___be",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/pl/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___pl",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___pl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ar/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ar",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ar",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/bn/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___bn",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___bn",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ko/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ko",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ko",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/sw/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___sw",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___sw",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/vi/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___vi",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___vi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/id/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___id",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___id",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/da/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___da",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___da",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/et/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___et",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___et",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/hu/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___hu",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___hu",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/lt/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___lt",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___lt",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/nb/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___nb",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___nb",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/ro/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___ro",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___ro",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/sl/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___sl",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___sl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/cs/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___cs",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___cs",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/el/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___el",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___el",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/fi/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___fi",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___fi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/lv/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___lv",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___lv",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/nl/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___nl",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___nl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/sk/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___sk",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___sk",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/sv/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___sv",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___sv",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta?.name,
    path: "/he/faq",
    meta: faqJvt4y_s5xwX8Pies3Cwy_45P1y1s967p2MwRQTeVHBuqcMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq.vue"),
    children: [
  {
    name: "faq___he",
    path: "",
    meta: indexl4TjfC4I300VR31EFU1nUkMKX7Y_45qiS4sOQe9cPXN1UMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/index.vue")
  },
  {
    name: "faq-slug___he",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/faq/[slug].vue")
  }
]
  },
  {
    name: "pst___ru",
    path: "/ru/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___en",
    path: "/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___es",
    path: "/es/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___fr",
    path: "/fr/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___de",
    path: "/de/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___it",
    path: "/it/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___pt",
    path: "/pt/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___zh",
    path: "/zh/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___bg",
    path: "/bg/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___tr",
    path: "/tr/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___ja",
    path: "/ja/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___ua",
    path: "/ua/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___th",
    path: "/th/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___hi",
    path: "/hi/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___be",
    path: "/be/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___pl",
    path: "/pl/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___ar",
    path: "/ar/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___bn",
    path: "/bn/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___ko",
    path: "/ko/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___sw",
    path: "/sw/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___vi",
    path: "/vi/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___id",
    path: "/id/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___da",
    path: "/da/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___et",
    path: "/et/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___hu",
    path: "/hu/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___lt",
    path: "/lt/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___nb",
    path: "/nb/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___ro",
    path: "/ro/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___sl",
    path: "/sl/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___cs",
    path: "/cs/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___el",
    path: "/el/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___fi",
    path: "/fi/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___lv",
    path: "/lv/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___nl",
    path: "/nl/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___sk",
    path: "/sk/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___sv",
    path: "/sv/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "pst___he",
    path: "/he/pst",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/pst.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___ua",
    path: "/ua",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___bn",
    path: "/bn",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___sw",
    path: "/sw",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___nb",
    path: "/nb",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he",
    meta: indexpR91ulHrnYFYilAT7VKsIdlGyAJvm_7jr8f_45iXb22qAMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/index.vue")
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ru/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ru",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ru",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___en",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___en",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/es/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___es",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___es",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/fr/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___fr",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___fr",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/de/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___de",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___de",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/it/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___it",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___it",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/pt/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___pt",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___pt",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/zh/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___zh",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___zh",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/bg/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___bg",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___bg",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/tr/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___tr",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___tr",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ja/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ja",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ja",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ua/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ua",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ua",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/th/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___th",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___th",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/hi/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___hi",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___hi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/be/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___be",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___be",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/pl/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___pl",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___pl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ar/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ar",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ar",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/bn/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___bn",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___bn",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ko/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ko",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ko",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/sw/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___sw",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___sw",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/vi/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___vi",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___vi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/id/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___id",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___id",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/da/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___da",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___da",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/et/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___et",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___et",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/hu/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___hu",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___hu",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/lt/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___lt",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___lt",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/nb/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___nb",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___nb",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/ro/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___ro",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___ro",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/sl/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___sl",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___sl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/cs/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___cs",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___cs",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/el/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___el",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___el",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/fi/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___fi",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___fi",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/lv/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___lv",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___lv",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/nl/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___nl",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___nl",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/sk/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___sk",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___sk",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/sv/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___sv",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___sv",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta?.name,
    path: "/he/legal",
    meta: legalGdIlar92MuaqfjCdZs14zMESxp4Eyn8jUtNOlouUMnIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal.vue"),
    children: [
  {
    name: "legal___he",
    path: "",
    meta: indexZfBorQ6cdfhqHR29xYhFXqHL1neTOEcSNfYApRAEN1cMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/index.vue")
  },
  {
    name: "legal-slug___he",
    path: ":slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/legal/[slug].vue")
  }
]
  },
  {
    name: "promo___ru",
    path: "/ru/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___en",
    path: "/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___es",
    path: "/es/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___fr",
    path: "/fr/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___de",
    path: "/de/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___it",
    path: "/it/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___pt",
    path: "/pt/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___zh",
    path: "/zh/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___bg",
    path: "/bg/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___tr",
    path: "/tr/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___ja",
    path: "/ja/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___ua",
    path: "/ua/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___th",
    path: "/th/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___hi",
    path: "/hi/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___be",
    path: "/be/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___pl",
    path: "/pl/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___ar",
    path: "/ar/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___bn",
    path: "/bn/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___ko",
    path: "/ko/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___sw",
    path: "/sw/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___vi",
    path: "/vi/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___id",
    path: "/id/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___da",
    path: "/da/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___et",
    path: "/et/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___hu",
    path: "/hu/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___lt",
    path: "/lt/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___nb",
    path: "/nb/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___ro",
    path: "/ro/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___sl",
    path: "/sl/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___cs",
    path: "/cs/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___el",
    path: "/el/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___fi",
    path: "/fi/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___lv",
    path: "/lv/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___nl",
    path: "/nl/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___sk",
    path: "/sk/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___sv",
    path: "/sv/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "promo___he",
    path: "/he/promo",
    meta: promoVWI8Qq_8yFNAy_jJar8tnxfIycNZWWHfabj6qKsDWIgMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/promo.vue")
  },
  {
    name: "private___ru",
    path: "/ru/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___en",
    path: "/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___es",
    path: "/es/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___fr",
    path: "/fr/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___de",
    path: "/de/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___it",
    path: "/it/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___pt",
    path: "/pt/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___zh",
    path: "/zh/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___bg",
    path: "/bg/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___tr",
    path: "/tr/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___ja",
    path: "/ja/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___ua",
    path: "/ua/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___th",
    path: "/th/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___hi",
    path: "/hi/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___be",
    path: "/be/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___pl",
    path: "/pl/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___ar",
    path: "/ar/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___bn",
    path: "/bn/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___ko",
    path: "/ko/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___sw",
    path: "/sw/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___vi",
    path: "/vi/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___id",
    path: "/id/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___da",
    path: "/da/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___et",
    path: "/et/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___hu",
    path: "/hu/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___lt",
    path: "/lt/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___nb",
    path: "/nb/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___ro",
    path: "/ro/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___sl",
    path: "/sl/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___cs",
    path: "/cs/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___el",
    path: "/el/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___fi",
    path: "/fi/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___lv",
    path: "/lv/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___nl",
    path: "/nl/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___sk",
    path: "/sk/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___sv",
    path: "/sv/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "private___he",
    path: "/he/private",
    meta: privatesFiE9DnhVvZqR_45hC0RDiIVLD9LjgJ77FUJROvC4lWTUMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private.vue")
  },
  {
    name: "cards-fb___ru",
    path: "/ru/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___en",
    path: "/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___es",
    path: "/es/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___fr",
    path: "/fr/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___de",
    path: "/de/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___it",
    path: "/it/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___pt",
    path: "/pt/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___zh",
    path: "/zh/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___bg",
    path: "/bg/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___tr",
    path: "/tr/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___ja",
    path: "/ja/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___ua",
    path: "/ua/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___th",
    path: "/th/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___hi",
    path: "/hi/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___be",
    path: "/be/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___pl",
    path: "/pl/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___ar",
    path: "/ar/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___bn",
    path: "/bn/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___ko",
    path: "/ko/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___sw",
    path: "/sw/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___vi",
    path: "/vi/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___id",
    path: "/id/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___da",
    path: "/da/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___et",
    path: "/et/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___hu",
    path: "/hu/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___lt",
    path: "/lt/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___nb",
    path: "/nb/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___ro",
    path: "/ro/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___sl",
    path: "/sl/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___cs",
    path: "/cs/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___el",
    path: "/el/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___fi",
    path: "/fi/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___lv",
    path: "/lv/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___nl",
    path: "/nl/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___sk",
    path: "/sk/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___sv",
    path: "/sv/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "cards-fb___he",
    path: "/he/cards/fb",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/fb.vue")
  },
  {
    name: "affiliate___ru",
    path: "/ru/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___en",
    path: "/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___es",
    path: "/es/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___fr",
    path: "/fr/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___de",
    path: "/de/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___it",
    path: "/it/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___pt",
    path: "/pt/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___zh",
    path: "/zh/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___bg",
    path: "/bg/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___tr",
    path: "/tr/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___ja",
    path: "/ja/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___ua",
    path: "/ua/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___th",
    path: "/th/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___hi",
    path: "/hi/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___be",
    path: "/be/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___pl",
    path: "/pl/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___ar",
    path: "/ar/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___bn",
    path: "/bn/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___ko",
    path: "/ko/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___sw",
    path: "/sw/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___vi",
    path: "/vi/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___id",
    path: "/id/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___da",
    path: "/da/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___et",
    path: "/et/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___hu",
    path: "/hu/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___lt",
    path: "/lt/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___nb",
    path: "/nb/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___ro",
    path: "/ro/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___sl",
    path: "/sl/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___cs",
    path: "/cs/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___el",
    path: "/el/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___fi",
    path: "/fi/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___lv",
    path: "/lv/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___nl",
    path: "/nl/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___sk",
    path: "/sk/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___sv",
    path: "/sv/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "affiliate___he",
    path: "/he/affiliate",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/affiliate.vue")
  },
  {
    name: "cards-adv___ru",
    path: "/ru/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___en",
    path: "/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___es",
    path: "/es/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___fr",
    path: "/fr/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___de",
    path: "/de/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___it",
    path: "/it/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___pt",
    path: "/pt/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___zh",
    path: "/zh/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___bg",
    path: "/bg/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___tr",
    path: "/tr/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___ja",
    path: "/ja/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___ua",
    path: "/ua/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___th",
    path: "/th/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___hi",
    path: "/hi/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___be",
    path: "/be/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___pl",
    path: "/pl/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___ar",
    path: "/ar/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___bn",
    path: "/bn/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___ko",
    path: "/ko/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___sw",
    path: "/sw/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___vi",
    path: "/vi/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___id",
    path: "/id/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___da",
    path: "/da/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___et",
    path: "/et/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___hu",
    path: "/hu/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___lt",
    path: "/lt/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___nb",
    path: "/nb/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___ro",
    path: "/ro/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___sl",
    path: "/sl/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___cs",
    path: "/cs/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___el",
    path: "/el/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___fi",
    path: "/fi/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___lv",
    path: "/lv/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___nl",
    path: "/nl/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___sk",
    path: "/sk/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___sv",
    path: "/sv/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "cards-adv___he",
    path: "/he/cards/adv",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/adv.vue")
  },
  {
    name: "extension___ru",
    path: "/ru/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___en",
    path: "/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___es",
    path: "/es/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___fr",
    path: "/fr/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___de",
    path: "/de/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___it",
    path: "/it/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___pt",
    path: "/pt/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___zh",
    path: "/zh/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___bg",
    path: "/bg/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___tr",
    path: "/tr/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___ja",
    path: "/ja/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___ua",
    path: "/ua/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___th",
    path: "/th/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___hi",
    path: "/hi/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___be",
    path: "/be/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___pl",
    path: "/pl/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___ar",
    path: "/ar/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___bn",
    path: "/bn/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___ko",
    path: "/ko/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___sw",
    path: "/sw/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___vi",
    path: "/vi/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___id",
    path: "/id/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___da",
    path: "/da/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___et",
    path: "/et/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___hu",
    path: "/hu/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___lt",
    path: "/lt/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___nb",
    path: "/nb/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___ro",
    path: "/ro/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___sl",
    path: "/sl/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___cs",
    path: "/cs/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___el",
    path: "/el/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___fi",
    path: "/fi/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___lv",
    path: "/lv/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___nl",
    path: "/nl/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___sk",
    path: "/sk/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___sv",
    path: "/sv/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "extension___he",
    path: "/he/extension",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/extension.vue")
  },
  {
    name: "worldwide___ru",
    path: "/ru/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___en",
    path: "/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___es",
    path: "/es/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___fr",
    path: "/fr/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___de",
    path: "/de/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___it",
    path: "/it/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___pt",
    path: "/pt/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___zh",
    path: "/zh/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___bg",
    path: "/bg/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___tr",
    path: "/tr/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___ja",
    path: "/ja/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___ua",
    path: "/ua/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___th",
    path: "/th/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___hi",
    path: "/hi/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___be",
    path: "/be/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___pl",
    path: "/pl/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___ar",
    path: "/ar/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___bn",
    path: "/bn/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___ko",
    path: "/ko/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___sw",
    path: "/sw/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___vi",
    path: "/vi/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___id",
    path: "/id/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___da",
    path: "/da/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___et",
    path: "/et/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___hu",
    path: "/hu/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___lt",
    path: "/lt/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___nb",
    path: "/nb/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___ro",
    path: "/ro/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___sl",
    path: "/sl/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___cs",
    path: "/cs/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___el",
    path: "/el/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___fi",
    path: "/fi/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___lv",
    path: "/lv/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___nl",
    path: "/nl/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___sk",
    path: "/sk/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___sv",
    path: "/sv/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "worldwide___he",
    path: "/he/worldwide",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/worldwide.vue")
  },
  {
    name: "mobile-app___ru",
    path: "/ru/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___en",
    path: "/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___es",
    path: "/es/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___fr",
    path: "/fr/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___de",
    path: "/de/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___it",
    path: "/it/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___pt",
    path: "/pt/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___zh",
    path: "/zh/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___bg",
    path: "/bg/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___tr",
    path: "/tr/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ja",
    path: "/ja/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ua",
    path: "/ua/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___th",
    path: "/th/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___hi",
    path: "/hi/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___be",
    path: "/be/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___pl",
    path: "/pl/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ar",
    path: "/ar/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___bn",
    path: "/bn/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ko",
    path: "/ko/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___sw",
    path: "/sw/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___vi",
    path: "/vi/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___id",
    path: "/id/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___da",
    path: "/da/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___et",
    path: "/et/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___hu",
    path: "/hu/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___lt",
    path: "/lt/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___nb",
    path: "/nb/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ro",
    path: "/ro/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___sl",
    path: "/sl/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___cs",
    path: "/cs/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___el",
    path: "/el/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___fi",
    path: "/fi/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___lv",
    path: "/lv/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___nl",
    path: "/nl/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___sk",
    path: "/sk/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___sv",
    path: "/sv/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___he",
    path: "/he/mobile-app",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/mobile-app.vue")
  },
  {
    name: "whitelabel___ru",
    path: "/ru/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___en",
    path: "/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___es",
    path: "/es/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___fr",
    path: "/fr/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___de",
    path: "/de/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___it",
    path: "/it/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___pt",
    path: "/pt/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___zh",
    path: "/zh/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___bg",
    path: "/bg/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___tr",
    path: "/tr/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___ja",
    path: "/ja/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___ua",
    path: "/ua/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___th",
    path: "/th/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___hi",
    path: "/hi/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___be",
    path: "/be/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___pl",
    path: "/pl/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___ar",
    path: "/ar/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___bn",
    path: "/bn/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___ko",
    path: "/ko/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___sw",
    path: "/sw/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___vi",
    path: "/vi/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___id",
    path: "/id/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___da",
    path: "/da/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___et",
    path: "/et/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___hu",
    path: "/hu/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___lt",
    path: "/lt/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___nb",
    path: "/nb/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___ro",
    path: "/ro/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___sl",
    path: "/sl/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___cs",
    path: "/cs/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___el",
    path: "/el/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___fi",
    path: "/fi/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___lv",
    path: "/lv/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___nl",
    path: "/nl/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___sk",
    path: "/sk/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___sv",
    path: "/sv/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "whitelabel___he",
    path: "/he/whitelabel",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/whitelabel.vue")
  },
  {
    name: "cards___ru",
    path: "/ru/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___en",
    path: "/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___es",
    path: "/es/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___fr",
    path: "/fr/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___de",
    path: "/de/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___it",
    path: "/it/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___pt",
    path: "/pt/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___zh",
    path: "/zh/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___bg",
    path: "/bg/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___tr",
    path: "/tr/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___ja",
    path: "/ja/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___ua",
    path: "/ua/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___th",
    path: "/th/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___hi",
    path: "/hi/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___be",
    path: "/be/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___pl",
    path: "/pl/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___ar",
    path: "/ar/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___bn",
    path: "/bn/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___ko",
    path: "/ko/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___sw",
    path: "/sw/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___vi",
    path: "/vi/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___id",
    path: "/id/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___da",
    path: "/da/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___et",
    path: "/et/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___hu",
    path: "/hu/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___lt",
    path: "/lt/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___nb",
    path: "/nb/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___ro",
    path: "/ro/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___sl",
    path: "/sl/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___cs",
    path: "/cs/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___el",
    path: "/el/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___fi",
    path: "/fi/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___lv",
    path: "/lv/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___nl",
    path: "/nl/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___sk",
    path: "/sk/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___sv",
    path: "/sv/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards___he",
    path: "/he/cards",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/index.vue")
  },
  {
    name: "cards-slug___ru",
    path: "/ru/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___en",
    path: "/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___es",
    path: "/es/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___fr",
    path: "/fr/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___de",
    path: "/de/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___it",
    path: "/it/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___pt",
    path: "/pt/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___zh",
    path: "/zh/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___bg",
    path: "/bg/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___tr",
    path: "/tr/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___ja",
    path: "/ja/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___ua",
    path: "/ua/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___th",
    path: "/th/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___hi",
    path: "/hi/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___be",
    path: "/be/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___pl",
    path: "/pl/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___ar",
    path: "/ar/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___bn",
    path: "/bn/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___ko",
    path: "/ko/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___sw",
    path: "/sw/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___vi",
    path: "/vi/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___id",
    path: "/id/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___da",
    path: "/da/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___et",
    path: "/et/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___hu",
    path: "/hu/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___lt",
    path: "/lt/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___nb",
    path: "/nb/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___ro",
    path: "/ro/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___sl",
    path: "/sl/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___cs",
    path: "/cs/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___el",
    path: "/el/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___fi",
    path: "/fi/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___lv",
    path: "/lv/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___nl",
    path: "/nl/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___sk",
    path: "/sk/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___sv",
    path: "/sv/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-slug___he",
    path: "/he/cards/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/[slug].vue")
  },
  {
    name: "cards-ultima___ru",
    path: "/ru/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___en",
    path: "/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___es",
    path: "/es/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___fr",
    path: "/fr/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___de",
    path: "/de/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___it",
    path: "/it/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___pt",
    path: "/pt/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___zh",
    path: "/zh/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___bg",
    path: "/bg/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___tr",
    path: "/tr/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___ja",
    path: "/ja/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___ua",
    path: "/ua/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___th",
    path: "/th/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___hi",
    path: "/hi/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___be",
    path: "/be/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___pl",
    path: "/pl/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___ar",
    path: "/ar/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___bn",
    path: "/bn/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___ko",
    path: "/ko/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___sw",
    path: "/sw/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___vi",
    path: "/vi/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___id",
    path: "/id/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___da",
    path: "/da/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___et",
    path: "/et/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___hu",
    path: "/hu/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___lt",
    path: "/lt/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___nb",
    path: "/nb/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___ro",
    path: "/ro/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___sl",
    path: "/sl/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___cs",
    path: "/cs/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___el",
    path: "/el/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___fi",
    path: "/fi/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___lv",
    path: "/lv/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___nl",
    path: "/nl/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___sk",
    path: "/sk/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___sv",
    path: "/sv/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "cards-ultima___he",
    path: "/he/cards/ultima",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/ultima.vue")
  },
  {
    name: "reviews___ru",
    path: "/ru/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___en",
    path: "/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___es",
    path: "/es/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___fr",
    path: "/fr/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___de",
    path: "/de/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___it",
    path: "/it/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___pt",
    path: "/pt/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___zh",
    path: "/zh/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___bg",
    path: "/bg/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___tr",
    path: "/tr/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___ja",
    path: "/ja/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___ua",
    path: "/ua/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___th",
    path: "/th/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___hi",
    path: "/hi/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___be",
    path: "/be/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___pl",
    path: "/pl/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___ar",
    path: "/ar/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___bn",
    path: "/bn/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___ko",
    path: "/ko/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___sw",
    path: "/sw/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___vi",
    path: "/vi/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___id",
    path: "/id/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___da",
    path: "/da/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___et",
    path: "/et/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___hu",
    path: "/hu/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___lt",
    path: "/lt/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___nb",
    path: "/nb/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___ro",
    path: "/ro/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___sl",
    path: "/sl/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___cs",
    path: "/cs/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___el",
    path: "/el/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___fi",
    path: "/fi/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___lv",
    path: "/lv/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___nl",
    path: "/nl/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___sk",
    path: "/sk/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___sv",
    path: "/sv/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "reviews___he",
    path: "/he/reviews",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/index.vue")
  },
  {
    name: "cards-platinum___ru",
    path: "/ru/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___en",
    path: "/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___es",
    path: "/es/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___fr",
    path: "/fr/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___de",
    path: "/de/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___it",
    path: "/it/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___pt",
    path: "/pt/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___zh",
    path: "/zh/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___bg",
    path: "/bg/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___tr",
    path: "/tr/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___ja",
    path: "/ja/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___ua",
    path: "/ua/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___th",
    path: "/th/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___hi",
    path: "/hi/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___be",
    path: "/be/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___pl",
    path: "/pl/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___ar",
    path: "/ar/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___bn",
    path: "/bn/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___ko",
    path: "/ko/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___sw",
    path: "/sw/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___vi",
    path: "/vi/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___id",
    path: "/id/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___da",
    path: "/da/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___et",
    path: "/et/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___hu",
    path: "/hu/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___lt",
    path: "/lt/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___nb",
    path: "/nb/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___ro",
    path: "/ro/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___sl",
    path: "/sl/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___cs",
    path: "/cs/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___el",
    path: "/el/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___fi",
    path: "/fi/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___lv",
    path: "/lv/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___nl",
    path: "/nl/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___sk",
    path: "/sk/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___sv",
    path: "/sv/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "cards-platinum___he",
    path: "/he/cards/platinum",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/platinum.vue")
  },
  {
    name: "payment-slug___ru",
    path: "/ru/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___en",
    path: "/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___es",
    path: "/es/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___fr",
    path: "/fr/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___de",
    path: "/de/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___it",
    path: "/it/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___pt",
    path: "/pt/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___zh",
    path: "/zh/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___bg",
    path: "/bg/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___tr",
    path: "/tr/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___ja",
    path: "/ja/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___ua",
    path: "/ua/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___th",
    path: "/th/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___hi",
    path: "/hi/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___be",
    path: "/be/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___pl",
    path: "/pl/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___ar",
    path: "/ar/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___bn",
    path: "/bn/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___ko",
    path: "/ko/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___sw",
    path: "/sw/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___vi",
    path: "/vi/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___id",
    path: "/id/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___da",
    path: "/da/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___et",
    path: "/et/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___hu",
    path: "/hu/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___lt",
    path: "/lt/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___nb",
    path: "/nb/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___ro",
    path: "/ro/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___sl",
    path: "/sl/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___cs",
    path: "/cs/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___el",
    path: "/el/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___fi",
    path: "/fi/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___lv",
    path: "/lv/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___nl",
    path: "/nl/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___sk",
    path: "/sk/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___sv",
    path: "/sv/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "payment-slug___he",
    path: "/he/payment/:slug()",
    meta: _91slug_93n2Pm2wKlpXOziWluIxoLnxE_45OUCEwBms_Z7I5nPs_5sMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/payment/[slug].vue")
  },
  {
    name: "reviews-slug___ru",
    path: "/ru/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___en",
    path: "/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___es",
    path: "/es/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___fr",
    path: "/fr/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___de",
    path: "/de/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___it",
    path: "/it/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___pt",
    path: "/pt/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___zh",
    path: "/zh/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___bg",
    path: "/bg/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___tr",
    path: "/tr/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___ja",
    path: "/ja/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___ua",
    path: "/ua/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___th",
    path: "/th/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___hi",
    path: "/hi/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___be",
    path: "/be/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___pl",
    path: "/pl/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___ar",
    path: "/ar/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___bn",
    path: "/bn/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___ko",
    path: "/ko/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___sw",
    path: "/sw/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___vi",
    path: "/vi/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___id",
    path: "/id/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___da",
    path: "/da/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___et",
    path: "/et/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___hu",
    path: "/hu/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___lt",
    path: "/lt/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___nb",
    path: "/nb/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___ro",
    path: "/ro/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___sl",
    path: "/sl/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___cs",
    path: "/cs/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___el",
    path: "/el/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___fi",
    path: "/fi/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___lv",
    path: "/lv/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___nl",
    path: "/nl/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___sk",
    path: "/sk/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___sv",
    path: "/sv/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "reviews-slug___he",
    path: "/he/reviews/:slug()",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/reviews/[slug].vue")
  },
  {
    name: "private-landing___ru",
    path: "/ru/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___en",
    path: "/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___es",
    path: "/es/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___fr",
    path: "/fr/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___de",
    path: "/de/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___it",
    path: "/it/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___pt",
    path: "/pt/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___zh",
    path: "/zh/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___bg",
    path: "/bg/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___tr",
    path: "/tr/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___ja",
    path: "/ja/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___ua",
    path: "/ua/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___th",
    path: "/th/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___hi",
    path: "/hi/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___be",
    path: "/be/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___pl",
    path: "/pl/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___ar",
    path: "/ar/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___bn",
    path: "/bn/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___ko",
    path: "/ko/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___sw",
    path: "/sw/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___vi",
    path: "/vi/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___id",
    path: "/id/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___da",
    path: "/da/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___et",
    path: "/et/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___hu",
    path: "/hu/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___lt",
    path: "/lt/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___nb",
    path: "/nb/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___ro",
    path: "/ro/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___sl",
    path: "/sl/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___cs",
    path: "/cs/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___el",
    path: "/el/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___fi",
    path: "/fi/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___lv",
    path: "/lv/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___nl",
    path: "/nl/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___sk",
    path: "/sk/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___sv",
    path: "/sv/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "private-landing___he",
    path: "/he/private-landing",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/private-landing.vue")
  },
  {
    name: "cards-payment-card___ru",
    path: "/ru/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___en",
    path: "/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___es",
    path: "/es/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___fr",
    path: "/fr/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___de",
    path: "/de/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___it",
    path: "/it/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___pt",
    path: "/pt/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___zh",
    path: "/zh/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___bg",
    path: "/bg/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___tr",
    path: "/tr/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___ja",
    path: "/ja/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___ua",
    path: "/ua/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___th",
    path: "/th/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___hi",
    path: "/hi/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___be",
    path: "/be/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___pl",
    path: "/pl/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___ar",
    path: "/ar/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___bn",
    path: "/bn/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___ko",
    path: "/ko/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___sw",
    path: "/sw/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___vi",
    path: "/vi/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___id",
    path: "/id/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___da",
    path: "/da/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___et",
    path: "/et/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___hu",
    path: "/hu/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___lt",
    path: "/lt/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___nb",
    path: "/nb/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___ro",
    path: "/ro/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___sl",
    path: "/sl/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___cs",
    path: "/cs/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___el",
    path: "/el/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___fi",
    path: "/fi/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___lv",
    path: "/lv/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___nl",
    path: "/nl/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___sk",
    path: "/sk/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___sv",
    path: "/sv/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-payment-card___he",
    path: "/he/cards/payment-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/payment-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ru",
    path: "/ru/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___en",
    path: "/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___es",
    path: "/es/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___fr",
    path: "/fr/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___de",
    path: "/de/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___it",
    path: "/it/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___pt",
    path: "/pt/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___zh",
    path: "/zh/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___bg",
    path: "/bg/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___tr",
    path: "/tr/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ja",
    path: "/ja/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ua",
    path: "/ua/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___th",
    path: "/th/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___hi",
    path: "/hi/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___be",
    path: "/be/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___pl",
    path: "/pl/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ar",
    path: "/ar/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___bn",
    path: "/bn/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ko",
    path: "/ko/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___sw",
    path: "/sw/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___vi",
    path: "/vi/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___id",
    path: "/id/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___da",
    path: "/da/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___et",
    path: "/et/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___hu",
    path: "/hu/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___lt",
    path: "/lt/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___nb",
    path: "/nb/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___ro",
    path: "/ro/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___sl",
    path: "/sl/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___cs",
    path: "/cs/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___el",
    path: "/el/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___fi",
    path: "/fi/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___lv",
    path: "/lv/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___nl",
    path: "/nl/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___sk",
    path: "/sk/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___sv",
    path: "/sv/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-debit-card___he",
    path: "/he/cards/virtual-debit-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-debit-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ru",
    path: "/ru/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___en",
    path: "/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___es",
    path: "/es/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___fr",
    path: "/fr/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___de",
    path: "/de/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___it",
    path: "/it/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___pt",
    path: "/pt/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___zh",
    path: "/zh/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___bg",
    path: "/bg/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___tr",
    path: "/tr/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ja",
    path: "/ja/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ua",
    path: "/ua/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___th",
    path: "/th/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___hi",
    path: "/hi/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___be",
    path: "/be/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___pl",
    path: "/pl/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ar",
    path: "/ar/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___bn",
    path: "/bn/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ko",
    path: "/ko/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___sw",
    path: "/sw/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___vi",
    path: "/vi/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___id",
    path: "/id/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___da",
    path: "/da/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___et",
    path: "/et/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___hu",
    path: "/hu/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___lt",
    path: "/lt/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___nb",
    path: "/nb/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___ro",
    path: "/ro/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___sl",
    path: "/sl/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___cs",
    path: "/cs/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___el",
    path: "/el/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___fi",
    path: "/fi/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___lv",
    path: "/lv/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___nl",
    path: "/nl/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___sk",
    path: "/sk/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___sv",
    path: "/sv/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "cards-virtual-prepaid-card___he",
    path: "/he/cards/virtual-prepaid-card",
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/cards/virtual-prepaid-card.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ru",
    path: "/ru/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___en",
    path: "/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___es",
    path: "/es/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___fr",
    path: "/fr/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___de",
    path: "/de/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___it",
    path: "/it/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___pt",
    path: "/pt/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___zh",
    path: "/zh/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___bg",
    path: "/bg/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___tr",
    path: "/tr/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ja",
    path: "/ja/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ua",
    path: "/ua/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___th",
    path: "/th/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___hi",
    path: "/hi/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___be",
    path: "/be/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___pl",
    path: "/pl/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ar",
    path: "/ar/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___bn",
    path: "/bn/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ko",
    path: "/ko/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___sw",
    path: "/sw/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___vi",
    path: "/vi/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___id",
    path: "/id/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___da",
    path: "/da/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___et",
    path: "/et/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___hu",
    path: "/hu/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___lt",
    path: "/lt/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___nb",
    path: "/nb/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___ro",
    path: "/ro/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___sl",
    path: "/sl/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___cs",
    path: "/cs/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___el",
    path: "/el/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___fi",
    path: "/fi/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___lv",
    path: "/lv/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___nl",
    path: "/nl/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___sk",
    path: "/sk/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___sv",
    path: "/sv/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: "marketing-landings-pst-ultima___he",
    path: "/he/marketing/landings/pst-ultima",
    meta: pst_45ultima4nz6SxjN97A_453M99zL_EziQOxVEDkHJnJoRfK_45rACyIMeta || {},
    component: () => import("/home/server/builds/landing-2025-04-22-14-33/pages/marketing/landings/pst-ultima.vue")
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ru/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/es/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/fr/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/de/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/it/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/pt/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/zh/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/bg/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/tr/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ja/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ua/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/th/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/hi/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/be/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/pl/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ar/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/bn/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ko/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sw/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/vi/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/id/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/da/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/et/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/hu/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/lt/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/nb/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ro/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sl/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/cs/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/el/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/fi/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/lv/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/nl/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sk/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sv/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/he/private-dashboard-old",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ru/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/es/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/fr/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/de/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/it/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/pt/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/zh/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/bg/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/tr/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ja/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ua/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/th/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/hi/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/be/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/pl/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ar/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/bn/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ko/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sw/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/vi/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/id/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/da/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/et/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/hu/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/lt/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/nb/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/ro/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sl/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/cs/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/el/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/fi/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/lv/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/nl/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sk/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/sv/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  },
  {
    name: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0Meta?.name,
    path: "/he/private-dashboard",
    component: component_45stubs3gCOyT2cvjzExB268VKlHODjP5EYKtZaM1vVLe8NF0
  }
]